import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRotateRight01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.822 15a9.6 9.6 0 0 1-9.122 6.6 9.6 9.6 0 1 1 8.316-14.4M17.1 8.4h4.8V3.6"
    />
  </svg>
);
export default SvgArrowRotateRight01;
